<template>
  <NewsList :config="config" />
</template>

<script>
import NewsList from "../../components/NewsList/NewsList.vue";

export default {
  name: "app",
  components: {
    NewsList
  },
  data() {
    return {
      config: JSON.parse(this.$options._parentVnode.data.props.config)
    };
  }
};
</script>
